// Inventory Page - Using MUI DataGrid and Bootstrap Modal
import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc, query, orderBy, limit } from "firebase/firestore";
import { db } from "../App";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Modal, Form } from "react-bootstrap";

const Inventory = () => {
  const [inventory, setInventory] = useState([]);
  const [newItem, setNewItem] = useState({
    partName: "",
    quantity: "",
    supplier: "",
    minStockLevel: "",
    maxStockLevel: "",
    lastRestocked: "",
    location: "",
    notes: "",
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchInventory = async () => {
      const querySnapshot = await getDocs(collection(db, "inventory"));
      const inventoryList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setInventory(inventoryList);
    };
    fetchInventory();
  }, []);

  const generatePartID = async () => {
    const partQuery = query(collection(db, "inventory"), orderBy("partID", "desc"), limit(1));
    const querySnapshot = await getDocs(partQuery);
    if (!querySnapshot.empty) {
      const lastID = querySnapshot.docs[0].data().partID;
      const newID = parseInt(lastID, 10) + 1;
      return newID.toString().padStart(5, "0");
    } else {
      return "00001";
    }
  };

  const handleAddItem = async () => {
    try {
      const newID = await generatePartID();
      const itemToAdd = { ...newItem, partID: newID };
      await addDoc(collection(db, "inventory"), itemToAdd);
      setInventory([...inventory, itemToAdd]);
      setNewItem({
        partName: "",
        quantity: "",
        supplier: "",
        minStockLevel: "",
        maxStockLevel: "",
        lastRestocked: "",
        location: "",
        notes: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error("Error adding inventory item: ", error);
    }
  };

  const columns = [
    { field: "partID", headerName: "Part ID", width: 150 },
    { field: "partName", headerName: "Part Name", width: 200 },
    { field: "quantity", headerName: "Quantity", width: 150 },
    { field: "supplier", headerName: "Supplier", width: 200 },
    { field: "minStockLevel", headerName: "Min Stock Level", width: 150 },
    { field: "maxStockLevel", headerName: "Max Stock Level", width: 150 },
    { field: "lastRestocked", headerName: "Last Restocked", width: 150 },
    { field: "location", headerName: "Location", width: 150 },
    { field: "notes", headerName: "Notes", width: 250 },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <h2>Inventory</h2>
      
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className="mb-2"
      >
        Add New Item
      </Button>
      
      <div style={{ height: 350, width: 1150 }}>
        <DataGrid
        getRowId={(row) => row.partName}
          rows={inventory}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
          style={{ backgroundColor: "white" }}
        />
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Part Name</Form.Label>
              <Form.Control
                type="text"
                value={newItem.partName}
                onChange={(e) => setNewItem({ ...newItem, partName: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                value={newItem.quantity}
                onChange={(e) => setNewItem({ ...newItem, quantity: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Supplier</Form.Label>
              <Form.Control
                type="text"
                value={newItem.supplier}
                onChange={(e) => setNewItem({ ...newItem, supplier: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Min Stock Level</Form.Label>
              <Form.Control
                type="number"
                value={newItem.minStockLevel}
                onChange={(e) => setNewItem({ ...newItem, minStockLevel: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Max Stock Level</Form.Label>
              <Form.Control
                type="number"
                value={newItem.maxStockLevel}
                onChange={(e) => setNewItem({ ...newItem, maxStockLevel: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Last Restocked</Form.Label>
              <Form.Control
                type="date"
                value={newItem.lastRestocked}
                onChange={(e) => setNewItem({ ...newItem, lastRestocked: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                value={newItem.location}
                onChange={(e) => setNewItem({ ...newItem, location: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={newItem.notes}
                onChange={(e) => setNewItem({ ...newItem, notes: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddItem}>
            Save Item
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Inventory;
